<template>
    <div class="row">
        <div :class="isPreviewActive ? 'col-sm-8': 'col-sm'">
            <div class="card-body">
                <form class="default-form" @submit="createItemSubmit" novalidate>

                    <div class="form-group">
                        <label for="nameInput">Naziv</label>
                        <input id="nameInput" class="form-control" type="text" placeholder="Naziv proizvoda" v-model="name"/>
                    </div>

                    <div class="form-group">
                        <label for="imageInput">Slika</label>
                        <input id="imageInput" class="form-control" type="text" placeholder="URL do slike proizvoda" v-model="imageUrl"/>
                    </div>

                    <div class="form-group">
                        <label for="descriptionInput">Opis</label>
                        <textarea id="descriptionInput" class="form-control" placeholder="Opis proizvoda" rows="5" v-model="description"/>
                    </div>

                    <div class="form-group">
                        <label for="ingredientsInput">Sastojci</label>
                        <textarea id="ingredientsInput" class="form-control" placeholder="Sastojci proizvoda" rows="5" v-model="ingredients"/>
                    </div>

                    <div class="form-group">
                        <div class="form-row">
                            <div class="col">
                                <label for="widthInput">Duzina (mm)</label>
                                <input id="widthInput" type="number" class="form-control" placeholder="Duzina proizvoda u milimetrima" min="0" v-model="width">
                            </div>
                            <div class="col">
                                <label for="heightInput">Visina (mm)</label>
                                <input id="heightInput" type="number" class="form-control" placeholder="Visina proizvoda u milimetrima" min="0" v-model="height">
                            </div>
                            <div class="col">
                                <label for="thicknessInput">Debljina (mm)</label>
                                <input id="thicknessInput" type="number" class="form-control" placeholder="Debljina proizvoda u milimetrima" min="0" v-model="thickness">
                            </div>
                            <div class="col">
                                <label for="weightInput">Tezina (g)</label>
                                <input id="weightInput" type="number" class="form-control" placeholder="Tezina proizvoda u gramima" min="0" v-model="weight">
                            </div>
                        </div>
                    </div>

                    <div class="form-group">
                        <div class="form-row">
                            <div class="col">
                                <label for="priceInput">Cena</label>
                                <input id="priceInput" type="number" class="form-control" placeholder="Cena proizvoda" min="0" v-model="price">
                            </div>
                            <div class="col">
                                <label for="discountInput">Popust</label>
                                <input id="discountInput" type="number" class="form-control" placeholder="Popust na cenu u procentima (0 - 100)" min="0" maxlength="100" v-model="discount">
                            </div>
                            <div class="col">
                                <label for="amountInput">Kolicina</label>
                                <input id="amountInput" type="number" class="form-control" placeholder="Kolicina proizvoda na stanju" min="0" v-model="amount">
                            </div>
                        </div>
                    </div>

                    <div class="form-group">
						<label for="itemIndexInput">Indeks proizvoda</label>
						<input id="itemIndexInput" class="form-control" type="number" placeholder="Index proizvoda" min="0" v-model="itemIndex"/>
                    </div>

                    <div class="form-group">
                        <label>Kategorije</label>
                        <b-form-select v-model="selectedCategory" :options="categories">
                            <template #first>
                                <b-form-select-option :value="null" disabled>Odaberi kategoriju</b-form-select-option>
                            </template>
                        </b-form-select>
                    </div>

                    <div v-if="selectedCategory === 'CANDLE'" class="form-group">
                        <label>Mirisi</label>
                        <div v-if="isFetchingItemSmells" class="text-muted">
                            Učitavanje mirisa...
                        </div>
                        <div v-else-if="smellOptions.length === 0" class="text-muted">
                            Nema dostupnih mirisa. Molimo vas prvo kreirajte mirise.
                        </div>
                        <div v-else>
                            <b-form-select 
                                v-model="selectedSmells" 
                                :options="smellOptions" 
                                multiple 
                                :select-size="4"
                                placeholder="Odaberi mirise">
                            </b-form-select>
                            <small class="form-text text-muted">
                                Možete odabrati više mirisa držeći Ctrl (Cmd na Mac) pritisnut
                            </small>
                            <div v-if="selectedSmells.length > 0" class="mt-2">
                                <small class="text-success">
                                    Odabrano mirisa: {{ selectedSmells.length }}
                                </small>
                            </div>
                        </div>
                    </div>

                    <div class="form-group">
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" id="availableInput" v-model="available">
                            <label class="form-check-label" for="availableInput">Dostupan</label>
                        </div>
                    </div>
                    <button type="submit" class="btn btn-primary">Napravi</button>
                    <button type="button" @click="isPreviewActive = !isPreviewActive" class="btn btn-secondary">Pregledaj</button>
                </form>
            </div>
        </div>

        <div v-if="isPreviewActive" class="col-sm-4">
            <div class="card-body">
                <ShopItem :item="{ imageUrl, name, price, available, discount }"/>
            </div>
        </div>
    </div>
</template>

<script>
import ShopItem from '@/component/user/shop/item/ShopItem'
import {mapActions, mapGetters} from 'vuex'

export default {
    name: 'AdminCreateItem',
    components: {
        ShopItem,
    },
    data() {
        return {
            name: '',
            description: '',
            imageUrl: '',
            width: 0,
            height: 0,
            thickness: 0,
            weight: 0,
            ingredients: '',
            price: 0,
            discount: 0,
            amount: 0,
            available: true,
            itemIndex: 0,
            isPreviewActive: false,
            selectedCategory: null,
            selectedSmells: []
        }
    },
    created() {
        this.fetchCategories()
        this.fetchAllItemSmells()
    },
    watch: {
        selectedCategory(newCategory, oldCategory) {
            if (oldCategory === 'CANDLE' && newCategory !== 'CANDLE') {
                this.selectedSmells = []
            }
        }
    },
    computed: {
        ...mapGetters([
            'getCategories',
            'getitemSmells',
            'isFetchingItemSmells'
        ]),

        categories: {
            get() {
                return this.getCategories.map(category => {
                    let text = category
                    if (category === 'BODY')
                        text = 'Nega Tela'
                    else if (category === 'FACE')
                        text = 'Nega Lica'
                    else if (category === 'HAIR')
                        text = 'Nega Kose (nije dostupno)'
                    else if (category === 'GIFTBOX')
                        text = 'Poklon Kutija'
                    else if (category === 'SAMPLE')
                        text = 'Uzorak'
                    else if (category === 'CANDLE')
                        text = 'Sveca'

                    return {
                        text: text,
                        value: category
                    }
                })
            }
        },

        smellOptions() {
            if (!this.getitemSmells || this.getitemSmells.length === 0) {
                return []
            }
            
            return this.getitemSmells.map(smell => ({
                text: smell.name || `Miris ${smell.id}`,
                value: smell.id
            }))
        }
    },
    methods: {
        ...mapActions([
            'saveItem',
            'fetchCategories',
            'fetchAllItemSmells'
        ]),

        createItemSubmit(e) {
            e.preventDefault()

            if (this.isFormValid()) {
                const itemData = {
                    name: this.name,
                    description: this.description,
                    imageUrl: this.imageUrl,
                    width: parseFloat(this.width),
                    height: parseFloat(this.height),
                    thickness: parseFloat(this.thickness),
                    weight: parseFloat(this.weight),
                    ingredients: this.ingredients,
                    amountInStock: parseInt(this.amount),
                    price: parseFloat(this.price),
                    discount: parseFloat(this.discount),
                    itemIndex: parseInt(this.itemIndex),
                    available: this.available,
                    category: this.selectedCategory
                }

                if (this.selectedCategory === 'CANDLE' && this.selectedSmells.length > 0) {
                    itemData.smells = this.selectedSmells.map(smellId => {
                        return {
                            id: smellId
                        }
                    })
                }

                this.saveItem(itemData)
                this.clearState()
            }
        },

        isFormValid() {
            if (!this.name) {
                this.$notify({
                    group: 'errors',
                    title: 'Greska u pravljenju proizvoda',
                    text: 'Ime ne moze da bude prazno!'
                })
                return false
            }

            if (!this.ingredients) {
                this.$notify({
                    group: 'errors',
                    title: 'Greska u pravljenju proizvoda',
                    text: 'Sastojci proizvoda ne mogu da budu prazni!'
                })
                return false
            }

            if (this.amount === 0) {
                this.$notify({
                    group: 'errors',
                    title: 'Greska u pravljenju proizvoda',
                    text: 'Kolicina ne moze da bude 0!'
                })
                return false
            }

            if (this.width === 0) {
                this.$notify({
                    group: 'errors',
                    title: 'Greska u pravljenju proizvoda',
                    text: 'Sirina ne moze da bude 0!'
                })
                return false
            }

            if (this.height === 0) {
                this.$notify({
                    group: 'errors',
                    title: 'Greska u pravljenju proizvoda',
                    text: 'Visina ne moze da bude 0!'
                })
                return false
            }

            if (this.thickness === 0) {
                this.$notify({
                    group: 'errors',
                    title: 'Greska u pravljenju proizvoda',
                    text: 'Debljina ne moze da bude 0!'
                })
                return false
            }

            if (this.weight === 0) {
                this.$notify({
                    group: 'errors',
                    title: 'Greska u pravljenju proizvoda',
                    text: 'Tezina ne moze da bude 0!'
                })
                return false
            }

            if (this.price === 0) {
                this.$notify({
                    group: 'warn',
                    title: 'Upozorenje',
                    text: 'Cena proizvoda je postavljena na 0!'
                })
            }

            if (this.selectedCategory === 'CANDLE' && this.selectedSmells.length === 0) {
                this.$notify({
                    group: 'errors',
                    title: 'Greska u pravljenju proizvoda',
                    text: 'Svece moraju imati bar jedan miris!'
                })
                return false
            }

            return true
        },

        clearState() {
            this.name = ''
            this.imageUrl = ''
            this.width = 0
            this.height = 0
            this.thickness = 0
            this.weight = 0
            this.ingredients = ''
            this.description = ''
            this.price = 0
            this.discount = 0
            this.amount = 0
            this.itemIndex = 0
            this.available = true
            this.isPreviewActive = false
            this.selectedCategory = null
            this.selectedSmells = []
        }
    }
}
</script>

<style scoped>
    .default-form button {
        width: 200px;
        margin-right: 10px;
        margin-bottom: 10px;
    }
</style>
